import size from "../sizes";
import image1 from "../../assets/images/materials/tee/1.jpg";
import image2 from "../../assets/images/materials/tee/2.jpg";
import image4 from "../../assets/images/materials/tee/4.jpg";
import image7 from "../../assets/images/materials/tee/7.jpg";
import image8 from "../../assets/images/materials/tee/8.jpg";
import image9 from "../../assets/images/materials/tee/9.jpg";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Очень удобная футболка модного фасона.  Мягкая и гладкая на ощупь ткань — это высококачественный Турецкий хлопок. Из-за дорогой цены, эта ткань в основном используется только для детской одежды. Легкая приталенность подчеркивает достоинства фигуры, а короткий свободный рукав и круглый ворот делают носку по-настоящему комфортной. Эта футболка обязательно станет вашей любимой.</p><p>Белый, черный, серый меланж: 100% холопок, плотность 200гр Остальные цвета: 90% хлопок, 10% лайкра, плотность 180гр</p>`,
      images: [
        {
          source: image1,
          captionContent: {
            title: `Удобная горловина`,
            description: `Край горловины выполнен из тонкой рибаны — трикотажной резинки, которая отлично тянется и при этом не деформируется от постоянной носки. Горловина чуть шире обычной, поэтому футболка совсем не давит на шею.`
          }
        },
        {
          source: image2,
          captionContent: {
            title: `Внимание к деталям`,
            description: `Лицевые и внутренние швы ровные и аккуратные: нигде не торчат нитки, строчка идет на одном расстоянии от края ткани. Ткань — 100% хлопок, пенье высшего качества, изготовленное из длинных нитей хлопчатобумажного волокна.`
          }
        },
        {
          source: image4,
          captionContent: {
            title: `Рукав облегает руку`,
            description: `Специальная резинка на рукаве подчеркивает силуэт. Рукав не топорщится, а гармонично облегает руку, при этом стесняет движений и не оставляет следов на коже.`
          }
        },
        {
          source: image7,
          captionContent: {
            title: `Хлопок наилучшего качества`,
            description: `Мы шьем футболки Wearcraft из хлопкового полотна высшего качества — пенье. Это тонкая ткань,  шелковистая на ощупь: благодаря особой шлифовке нитей она не скатывается и устойчива к истиранию.`
          }
        },
        {
          source: image8,
          captionContent: {
            title: `Стройный силуэт`,
            description: `Благодаря правильной длине, чуть приталенному силуэту и качественной ткани футболка сидит ровно, не образуя лишних складок. Рукав подчеркивает форму руки, не топорщится и выглядит стильно.`
          }
        },
        {
          source: image9,
          captionContent: {
            title: `Простой уход`,
            description: `Мы создали футболки Wearcraft для тех, кто ценит практичность и комфорт. Следуйте простой инструкции по уходу за изделием, чтобы наши футболки служили вам долгие годы.`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`tee`],
      sizeInfo: `tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
